import { Pipe, PipeTransform } from "@angular/core";
import { BatchSalesReport } from "@models/batch-sales-report";

@Pipe({
  name: "groupGuests",
  standalone: true,
})
export class GroupGuestsPipe implements PipeTransform {
  transform(data: BatchSalesReport[]): BatchSalesReport[] {
    if (!Array.isArray(data)) {
      return data;
    }

    const guests = data.filter((item) => item.title === "Guests");
    const others = data.filter((item) => item.title !== "Guests");

    if (guests.length) {
      const groupedGuest = guests.reduce(
        (acc, curr) => {
          acc.sold_quantity += curr.sold_quantity;
          return acc;
        },
        {
          ...guests[0],
          sold_quantity: 0,
        },
      );

      return [...others, groupedGuest];
    }

    return data;
  }
}
